import { Collection } from '@aipb/personal-content/shared/model';
import { selectLoading, updateLoading, withLoading } from '@aipb/util/state';
import { Injectable } from '@angular/core';
import { createStore, select, withProps } from '@ngneat/elf';
import {
  addEntities,
  deleteAllEntities,
  deleteEntities,
  getActiveEntity,
  getEntity,
  selectActiveEntity,
  selectAllEntities,
  selectEntity,
  setActiveId,
  upsertEntitiesById,
  withActiveId,
  withEntities
} from '@ngneat/elf-entities';
import { Observable } from 'rxjs';

interface FavoriteCollectionProps {
  isLoading: {
    [key: string]: boolean;
  };
}

const store = createStore(
  { name: 'personal-content-favorite-collection' },
  withLoading(),
  withEntities<Collection>(),
  withActiveId(),
  withProps<FavoriteCollectionProps>({
    isLoading: {}
  })
);

@Injectable({
  providedIn: 'root'
})
export class FavoriteCollectionRepository {
  loading$ = store.pipe(selectLoading());
  collections$ = store.pipe(selectAllEntities());

  get active(): Collection {
    // @ts-expect-error foo
    return store.query(getActiveEntity());
  }

  selectCollectionLoading(id: string): Observable<boolean> {
    return store.pipe(select((state) => (id in state.isLoading ? state.isLoading[id] : false)));
  }

  selectCollection(id: Collection['id']) {
    return store.pipe(selectEntity(id));
  }

  selectActiveCollection() {
    return store.pipe(selectActiveEntity());
  }

  getCollection(id: Collection['id']) {
    return store.query(getEntity(id));
  }

  addCollection(collection: Collection) {
    store.update(addEntities(collection));
  }

  updateCollection(id: Collection['id'], collection: Collection) {
    store.update(
      upsertEntitiesById(id, {
        updater: (entity) => ({
          // @ts-expect-error foo
          nibbles: entity.nibbles,
          // @ts-expect-error foo
          breadcrumbs: entity.breadcrumbs,
          // @ts-expect-error foo
          relations: entity.relations,
          url: entity.url,
          ...collection
        }),
        creator: (id) => collection
      })
    );
  }

  removeCollection(id: Collection['id']) {
    store.update(deleteEntities(id));
  }

  removeAllCollections() {
    store.update(deleteAllEntities());
  }

  setActiveCollection(id: Collection['id']) {
    store.update(setActiveId(id));
  }

  setCollectionLoading(id: string, loading: boolean) {
    store.update((state) => ({
      ...state,
      isLoading: {
        ...state.isLoading,
        [id]: loading
      }
    }));
  }

  setLoading(loading: boolean) {
    store.update(updateLoading(loading));
  }

  reset() {
    store.reset();
  }
}
